import { render, staticRenderFns } from "./coaching_stats.vue?vue&type=template&id=3c533e87&scoped=true&"
import script from "./coaching_stats.vue?vue&type=script&lang=js&"
export * from "./coaching_stats.vue?vue&type=script&lang=js&"
import style0 from "./coaching_stats.vue?vue&type=style&index=0&id=3c533e87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c533e87",
  null
  
)

export default component.exports